import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=837b3c8e&scoped=true"
import script from "./Candidates.vue?vue&type=script&lang=js"
export * from "./Candidates.vue?vue&type=script&lang=js"
import style0 from "./Candidates.vue?vue&type=style&index=0&id=837b3c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837b3c8e",
  null
  
)

export default component.exports